import Table from "react-bootstrap/Table";

function DetailsTable() {
  return (
    <Table striped bordered hover>
      <thead>
        <tr>
          <th style={{ backgroundColor: "#007bff", color: "white" }}>S.No.</th>
          <th style={{ backgroundColor: "#007bff", color: "white" }}>
            Information
          </th>
          <th style={{ backgroundColor: "#007bff", color: "white" }}>
            Details
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td>Total Campus Area of the School (in square meters)</td>
          <td>4050</td>
        </tr>
        <tr>
          <td>2</td>
          <td>No. and Size of the Classrooms (in square feet / meters)</td>
          <td>23 & 47</td>
        </tr>
        <tr>
          <td>3</td>
          <td>
            No. and Size of Laboratories Including Computer Labs (in square feet
            / meters)
          </td>
          <td>6 & 56</td>
        </tr>
        <tr>
          <td>4</td>
          <td>Internet Facility</td>
          <td>YES</td>
        </tr>
        <tr>
          <td>5</td>
          <td>No. of Girls Toilets</td>
          <td>15</td>
        </tr>
        <tr>
          <td>6</td>
          <td>No. of Boys Toilets</td>
          <td>15</td>
        </tr>
        <tr>
          <td>7</td>
          <td>
            Link Of Youtube video of the inspection of school covering the
            infrastructure of the school
          </td>
          {
            <td>
              <a
                href="https://www.youtube.com/watch?v=u5ZEa-PuCZo&t=85s"
                class="doc-link"
              >
                Click To Watch
              </a>
            </td>
          }
        </tr>
      </tbody>
    </Table>
  );
}

export default DetailsTable;
